import React from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core'

const ConfirmMassDeleteDialog = ({
  open,
  count,
  loading,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Remover alunos selecionados?</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="textSecondary">
        Você está prestes a remover <strong>{count}</strong>{' '}
        {count === 1 ? 'aluno' : 'alunos'} do curso. Esta ação não pode ser
        desfeita.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="outlined" disabled={loading}>
        Cancelar
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        color="secondary"
        disabled={loading}
      >
        Excluir
      </Button>
    </DialogActions>
  </Dialog>
)

export default ConfirmMassDeleteDialog
